module.exports = __webpack_public_path__ + "static/html-img-ce2109343e5948ebd2d914e53db968ba.jpg";